import React from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

const AddReview = () => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const imageStorageKey = "8a2fd622b09fe164cd5a3cd0097a5b35";

  const onSubmit = async (data) => {
    const image = data.image[0];
    const formData = new FormData();
    formData.append("image", image);
    const url = `https://api.imgbb.com/1/upload?key=${imageStorageKey}`;
    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          const img = result.data.url;
          const review = {
            name: data.name,
            retting: data.retting,
            review: data.review,
            img: img,
          };
          // send to your database
          fetch("https://mbababd24.onrender.com/review", {
            method: "POST",
            headers: {
              "content-type": "application/json",
            },
            body: JSON.stringify(review),
          })
            .then((res) => res.json())
            .then((inserted) => {
              if (inserted.insertedId) {
                toast.success("Review added successfully");
                reset();
              } else {
                toast.error("Failed to add the Review");
              }
            });
        }
      });
  };

  return (
    <div className="flex justify-center items-center">
      <div className="card p-10 w-96 shadow-2xl border-2 border-white mx-4">
        <h2 className="text-2xl text-center text-accent">Add a New Review</h2>
        <div className="text-center text-accent">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-control w-full max-w-xs mx-auto">
              <label className="label">
                <span className="label-text text-accent">Name</span>
              </label>
              <input
                type="text"
                placeholder="Your Name"
                className="input input-bordered w-full max-w-xs  mx-auto"
                {...register("name", {
                  required: {
                    value: true,
                    message: "Name is Required",
                  },
                })}
              />
              <label className="label">
                {errors.name?.type === "required" && (
                  <span className="label-text text-accent-alt text-red-500">
                    {errors.name.message}
                  </span>
                )}
              </label>
            </div>

            <div className="form-control w-full max-w-xs  mx-auto">
              <label className="label">
                <span className="label-text text-accent">Retting</span>
              </label>
              <input
                type="number"
                placeholder="Your Retting"
                className="input input-bordered w-full max-w-xs"
                {...register("retting", {
                  required: {
                    value: true,
                    message: "Retting is Required",
                  },
                  pattern: {
                    value: /^[0-5]?$|^5$/,
                    message: "Provide our 5 star rating",
                  },
                })}
              />
              <label className="label">
                {errors.retting?.type === "required" && (
                  <span className="label-text text-accent-alt text-red-500">
                    {errors.retting.message}
                  </span>
                )}
              </label>
              {errors.retting?.type === "pattern" && (
                <span className="label-text text-accent-alt text-red-500">
                  {errors.retting.message}
                </span>
              )}
            </div>
            <div className="form-control w-full max-w-xs  mx-auto">
              <label className="label">
                <span className="label-text text-accent">Review</span>
              </label>
              <textarea
                type="textarea"
                placeholder="Your Review"
                className="textarea textarea-bordered w-full max-w-xs  mx-auto"
                {...register("review", {
                  required: {
                    value: true,
                    message: "Review is Required",
                  },
                })}
              />
              <label className="label">
                {errors.review?.type === "required" && (
                  <span className="label-text text-accent-alt text-red-500">
                    {errors.review.message}
                  </span>
                )}
              </label>
            </div>
            <div className="form-control w-full max-w-xs  mx-auto">
              <label className="label">
                <span className="label-text text-accent">Photo</span>
              </label>
              <input
                type="file"
                className="input input-bordered w-full max-w-xs  mx-auto"
                {...register("image", {
                  required: {
                    value: true,
                    message: "Image is Required",
                  },
                })}
              />
              <label className="label">
                {errors.image?.type === "required" && (
                  <span className="label-text text-accent-alt text-red-500">
                    {errors.image.message}
                  </span>
                )}
              </label>
            </div>

            <input
              className="btn w-full max-w-xs text-accent bg-gradient-to-r from-secondary-400 to-primary-500 hover:from-green-500 hover:to-blue-500"
              type="submit"
              value="Add"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddReview;
